import api from 'app/api';
import store from 'app/store';
import mixpanel from 'mixpanel-browser';

export const signup = async (payload, callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'APP:SET_JWT_TOKEN', data: data });
    getCurrentUser(callback);
  };

  await api.post(
    `/auth/google`,
    payload,
    {
      id: 'sign-up',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

export const sendEmail = async (email, callback) => {
  const successCallback = ({ data }) => {
    if (callback) callback(data);
  };

  await api.get(
    `/auth/login`,
    {
      id: 'magic-link-login',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params: {
        email,
      },
    },
  );
};

export const authenticateUser = async (token, callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'APP:SET_JWT_TOKEN', data: data });

    if (callback) callback(data);
  };

  await api.get(
    `/auth/login/${token}`,
    {
      id: 'magic-link-auth',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

export const refreshSessionToken = async (callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'APP:SET_JWT_TOKEN', data: data, refresh: true });

    if (callback) callback(data);
  };

  return api.get(
    `/auth/refresh-session`,
    {
      id: 'refresh-token',
      success: {
        callback: successCallback,
      },
      failure: {
        // showNotifier: true,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tmt-refreshToken')}`,
      },
    },
  );
};

export const generateGuestToken = async (callback) => {
  const successCallback = ({ data }) => {
    if (!localStorage?.getItem('tmt-sessionToken')) {
      store.dispatch({ type: 'APP:SET_GUEST_JWT_TOKEN', data: data });
    }

    if (callback) callback(data);
  };

  await api.get(
    `/auth/guest-token`,
    {
      id: 'fetch-guest-token',
      success: {
        callback: successCallback,
      },
    },
  );
};

export const getCurrentUser = async (callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'APP:USER_DATA:SET', data });
     // Identify the user in Mixpanel
    mixpanel.identify(data._id);

    // Set people properties in Mixpanel
    mixpanel.people.set({
      '$name': data.name,
      '$email': data.email,
    });

    console.log("Login successful! User profile:", {
      '$name': data.name,
      '$email': data.email,
    });

    if (callback) callback(data);
  };

  const failureCallback = (data) => {
    store.dispatch({ type: 'APP:USER_DATA:SET', data: { isAdmin: false } });
    

    if (callback) callback(data);
  };

  await api.get(
    `/user`,
    {
      id: 'fetch-current-user',
      success: {
        callback: successCallback,
      },
      failure: {
        callback: failureCallback,
      },
      params: {
        location: localStorage?.selectedLocation?.toLowerCase(),
      },
    },
  );
};

export const saveProfile = async (payload, callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'APP:USER_DATA:SET', data });

    if (callback) callback(data);
  };

  await api.put(
    `/user/edit-profile`,
    payload,
    {
      id: 'save-user-data',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

// Mock login api for testing 
export const testSignup = async (payload, callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'APP:SET_JWT_TOKEN', data: data });
    getCurrentUser(callback);
  };

  await api.post(
    `/test-login`,
    payload,
    {
      id: 'test-sign-up',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};
